export function whenIdle(task: () => void): () => void {
    if (typeof window.requestIdleCallback === "function") {
        const handle = window.requestIdleCallback(task, { timeout: 2_000 });
        return () => window.cancelIdleCallback(handle);
    }

    const handle = window.setTimeout(task, 200);
    return () => window.clearTimeout(handle);
}
